import Controller from '@ember/controller';
import { service } from '@ember/service';
import {
  ROUTE_NAME_FOR_STAGE_EDITORS,
  ROUTE_NAME_FOR_STAGE_VIEWERS,
  STAGES,
} from 'lumen/utils/constants/otb-selfservice-constants';

export default class HotelSettingsMyotbController extends Controller {
  // This QP tells which product the user used to enter the Self service flow
  queryParams = ['via'];

  @service myotbSs;

  @service router;

  get showDataBar() {
    if (
      this.router.currentRouteName ===
        ROUTE_NAME_FOR_STAGE_VIEWERS[STAGES.INTRO_PAGE] ||
      this.router.currentRouteName ===
        ROUTE_NAME_FOR_STAGE_VIEWERS[STAGES.AUTOMATIC_SETUP_NOT_POSSIBLE]
    ) {
      return false;
    }

    const stagesWithoutDataBar = [
      STAGES.PMS_UNSUPPORTED_PAGE,
      STAGES.INTEGRATION_ACTIVE_PAGE,
    ];

    return (
      this.myotbSs.canUserEditOtb &&
      !stagesWithoutDataBar.some((stageWithoutDataBar) =>
        this.router.currentRouteName.includes(
          ROUTE_NAME_FOR_STAGE_EDITORS[stageWithoutDataBar],
        ),
      )
    );
  }

  get showSummaryBasket() {
    if (
      this.router.currentRouteName ===
        ROUTE_NAME_FOR_STAGE_VIEWERS[STAGES.INTRO_PAGE] ||
      this.router.currentRouteName ===
        ROUTE_NAME_FOR_STAGE_VIEWERS[STAGES.AUTOMATIC_SETUP_NOT_POSSIBLE]
    ) {
      return false;
    }

    const { id, stage } = this.myotbSs.otbSelfService;

    // Some integrations have no otbselfservice, but they can still see the active page.
    // In that case the summary basket will be empty because no properties are set on the otbselfservice.
    // So don't show it because it's empty anyway.
    const isActiveIntegrationWithoutOtbSelfServiceFlow =
      id === '-1' && stage === STAGES.INTEGRATION_ACTIVE_PAGE;

    return (
      this.myotbSs.canUserEditOtb &&
      !isActiveIntegrationWithoutOtbSelfServiceFlow
    );
  }
}
